<template>
  <div class="pt-3">
    <ValidationIcon :value="value || exludeValidation" />
    {{ label }}
    <span class="font-weight-bold">{{ value }}</span>
  </div>
</template>

<script>
import ValidationIcon from '@/components/indicators/ValidationIcon.vue';

export default {
  name: 'ReviewItem',
  props: {
    label: {
      type: String,
    },
    value: {
      required: true,
    },
    exludeValidation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { ValidationIcon },
};
</script>
